import { setGameHole } from './ggGamesData.js'
// Snake per-hole panel — tap whoever 3-putted this hole (holds the snake).
// Writes ggGames/{id}/snake/{hole} = { playerId } (null = nobody).
export default function GSnakeHoleInputs({ gameId, game, hole }) {
  const players = game.players || []
  const cur = game.snake?.[hole]?.playerId ?? null
  const pick = (pid) => setGameHole(gameId, 'snake', hole, { playerId: cur === pid ? null : pid })
  return (
    <div style={{ border: '1px solid #E5E7EB', borderRadius: 12, padding: 10, marginBottom: 10, background: '#FBFBF7' }}>
      <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4 }}>🐍 Three-putt this hole? <span style={{ color: '#888', fontWeight: 400 }}>· holds the snake</span></div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {players.map((p) => {
          const on = cur === p.id
          return <button key={p.id} onClick={() => pick(p.id)} style={{ padding: '5px 12px', borderRadius: 999, fontSize: 13, fontWeight: 700, cursor: 'pointer', border: `1px solid ${on ? '#B42318' : '#ccc'}`, background: on ? '#B42318' : '#fff', color: on ? '#fff' : '#333' }}>{p.name.split(' ')[0]}</button>
        })}
      </div>
    </div>
  )
}
